import React, { PropsWithChildren } from 'react';

type Props = {
  className?: string;
  btnType?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const buttonType: Record<string, string> = {
  primary: 'bg-secondaryYellow text-white hover:bg-[#F6A150]',
  secondary: 'bg-primary/20 text-primary hover:bg-primary/40',
  dark: 'bg-primary text-white hover:bg-primary/85',
};

function Button({ className, btnType, children, ...props }: PropsWithChildren<Props>) {
  const button =
    'flex justify-center font-medium font-roboto border-none cursor-pointer rounded transition-all duration-500 ease-in-out text-base p-4 tracking-[0.15px] disabled:opacity-50 disabled:cursor-default disabled:pointer-events-none';
  return (
    <button className={`${button} ${buttonType[btnType ?? 'primary']} ${className ?? ''}`} {...props}>
      {children}
    </button>
  );
}

export default Button;
